import React, { useContext, useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Modal from "react-bootstrap/Modal";
import completeCard from "../../img/complete_card.jpeg";
import ticket from "../../img/ticket.jpg";
import Image from "react-bootstrap/Image";
import Grid from "@material-ui/core/Grid";
// import Button from 'react-bootstrap/Button';
import IconButton from "@material-ui/core/IconButton";
import QuizContent from "./quizContent";
import MobileStepper from "@material-ui/core/MobileStepper";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import box from "../../img/box.png";
import PortfolioContext from "../../context/context";
import Tada from "react-reveal/Tada";

// function Copyright() {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center" >
//       {'Copyright © '}
//       <Link color="inherit" href="https://material-ui.com/">
//         Your Website
//       </Link>{' '}

//       {new Date().getFullYear()}
//       {'.'}
//     </Typography>
//   );
// }

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: "auto",
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
    zIndex: "5",
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  border: {
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
  },
  boxBtn: {
    marginTop: theme.spacing(7),
    marginLeft: theme.spacing(0),
    marginBottom: theme.spacing(4),
  },
  boxBtnMobile: {
    marginTop: theme.spacing(5),
    marginLeft: theme.spacing(0),
    marginBottom: theme.spacing(3),
  },
  // box: {
  //   width: "100%",
  //   height: "100%",
  // },
}));

const steps = [
  "Stage 1",
  "Stage 2",
  "Stage 3",
  "Stage 4",
  "Stage 5",
  "Stage 6",
  "Stage 7",
];

function getStepContent(step) {
  return <QuizContent idx={step} />;
}
const hunterment = [
  "이번주에도 잘 찾아왔군! 여기 단서를 줄테니 단서를 보고 각 Stage에 해당하는 분과에 소속된 동아리 부스에서 답을 찾아 퀴즈를 풀어봐! 자세한 내용은 아래 이벤트 소개를 참고하도록!",
  "잠에 들면 안돼!! 함정에 빠지지 않도록 조심하도록!",
  "거기를 걷다보면 자신도 모르게 바보가 될 수 있어!. 얼른 탈출해야해!!",
  "희망과 기대가 가득찬 공간이야! 지치지 않게 조금 쉬어가도록~",
  "그 버스를 타면 지옥이 무엇인지 알 수 있지... 이겨낼 수 있을거야 힘내!!",
  "대부분의 사람들이 여기서 포기하고 가지... 하지만 너는 다를거라 생각한다!! 죽음의 절벽이 아니라 성공의 절벽으로 만들어 줘!",
  "드디어 마지막 관문인 비밀의 문이군!! 마지막 퀴즈도 성공해서 보물을 찾아봐!! 엄청난 보물이 너를 기다리고 있어!",
  "정말 해냈군!! 해낼거라 믿었있어!! 명지보물섬의 엄청나고 신비한 보물이 뭔지 얼른 확인해보라구!! (참여해주신 모든 분들 정말 감사합니다.)",
];

const getCntCorrect = () => {
  let local = JSON.parse(localStorage.getItem("qa"));
  if (local === null) {
    return 0;
  }
  let cnt = 0;
  for (let i = 0; i < local.length; i++) {
    if (local[i] !== "") {
      cnt++;
    }
  }
  return cnt;
};

function Test() {
  const classes = useStyles();
  const theme = useTheme();

  const { departmentObj } = useContext(PortfolioContext);
  const [cntCorrect, setCntCorrect] = useState(getCntCorrect());
  const [activeStep, setActiveStep] = React.useState(cntCorrect);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [show, setShow] = useState(false);
  const [counter, setCounter] = useState(0);
  const [userName, setUserName] = useState(localStorage.getItem("mju_name"));
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleNext = () => {
    const btn = document.getElementById("submitAnser");
    const ment = document.querySelector(".hunterMent");
    if (btn.firstChild.innerText != "정답!") {
      ment.innerText = "정답을 맞춰야 다음으로 넘어갈 수 있어!!";
    } else {
      ment.id = `hunterMent${activeStep + 1}`;
      ment.innerText = hunterment[activeStep + 1];
      setActiveStep(activeStep + 1);
    }
  };
  const handleBoxClick = () => {
    setCounter(counter + 1);
  };
  const handleBack = () => {
    const ment = document.querySelector(".hunterMent");
    ment.id = `hunterMent${activeStep - 1}`;
    setActiveStep(activeStep - 1);
    ment.innerText = hunterment[activeStep - 1];
  };
  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
    if (activeStep === steps.length) {
      const { quiz } = departmentObj;
      const num = document.getElementsByClassName("passnumber");
      for (let i = 0; i < activeStep; i++) {
        console.log(i);
        num[i].innerHTML = quiz[i].num;
      }
    }
  });
  return (
    <React.Fragment>
      <CssBaseline />
      <Modal
        style={{ weight: "80%" }}
        show={show}
        onHide={handleClose}
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>보물의 정체는??</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ height: "60vh", display: "flex", justifyContent: "center" }}
        >
          <Image src={ticket} fluid style={{ height: "100%" }} />
          {/* <div id="completeCard">
            <span id="completeCardMent">{userName}</span>
          </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button variant="primary">Understood</Button> */}
        </Modal.Footer>
      </Modal>
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          {/* <Typography component="h1" variant="h4" align="center" >
            퀘스트
          </Typography> */}

          {isDesktop ? (
            <Stepper
              activeStep={activeStep}
              className={classes.stepper}
              alternativeLabel={true}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          ) : (
            <></>
          )}
          <React.Fragment>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Grid container>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      상자를 클릭하고 아래의 이벤트에 참여해보세요!
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div style={{ textAlign: "center" }}>
                      {/* <Button
                        variant="contained"
                        // color="primary"
                        onClick={handleShow}
                        className={classes.boxBtn}
                      >
                        보물상자 열기
                      </Button> */}
                      <IconButton
                        onClick={() => {
                          handleBoxClick();
                          setTimeout(handleShow, 1400);
                        }}
                        className={
                          isDesktop ? classes.boxBtn : classes.boxBtnMobile
                        }
                      >
                        <Tada spy={counter}>
                          <img id="box" src={box} className={classes.box} />
                        </Tada>
                      </IconButton>
                    </div>
                  </Grid>
                </Grid>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {/* {activeStep !== undefined ? <QuizContent idx={activeStep} /> : <></>} */}
                <QuizContent idx={activeStep} />
                {isMobile ? (
                  <>
                    <br></br>
                    <br></br>
                    <MobileStepper
                      variant="dots"
                      steps={8}
                      position="static"
                      activeStep={activeStep}
                      className={classes.root}
                      nextButton={
                        <Button
                          size="small"
                          onClick={handleNext}
                          disabled={activeStep === 8}
                        >
                          {activeStep === steps.length - 1
                            ? "Complete"
                            : "Next"}
                          {theme.direction === "rtl" ? (
                            <KeyboardArrowLeft />
                          ) : (
                            <KeyboardArrowRight />
                          )}
                        </Button>
                      }
                      backButton={
                        <Button
                          size="small"
                          onClick={handleBack}
                          disabled={activeStep === 0}
                        >
                          {theme.direction === "rtl" ? (
                            <KeyboardArrowRight />
                          ) : (
                            <KeyboardArrowLeft />
                          )}
                          Back
                        </Button>
                      }
                    />
                  </>
                ) : (
                  <div className={classes.buttons}>
                    {activeStep !== 0 && (
                      <Button onClick={handleBack} className={classes.button}>
                        Back
                      </Button>
                    )}
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.button}
                    >
                      {activeStep === steps.length - 1 ? "Complete" : "Next"}
                    </Button>
                  </div>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        </Paper>
        {/* <Copyright /> */}
      </main>
    </React.Fragment>
  );
}
export default Test;
